<nav>
  <div class="nav nav-tabs row bg-img-top-menu p-0" id="nav-tab" role="tablist">
    <div class="col-9 my-auto">
      <ul class="nav nav-tabs pt-3">
        <li class="nav-item">
          <a class="nav-link tab-menu active" data-toggle="tab" href="#CustomerProfile" (click)="onProfileTabClick()">
            <span class="fa fa-user fa-lg"></span>
            Customer Profile
          </a>
        </li>
        <li class="nav-item ml-3">
          <a class="nav-link tab-menu" data-toggle="tab" href="#Details" (click)="onDetailTabClick()">
            <span class="fa fa-list fa-lg"></span>
            Details
          </a>
        </li>
        <li class="nav-item ml-3">
          <a class="nav-link tab-menu" data-toggle="tab" href="#ContactReport" (click)="onHistoryTabClick()">
            <span class="fa fa-file-alt fa-lg"></span>
            รายงานการติดต่อ
          </a>
        </li>
        <li class="nav-item ml-3">
          <a class="nav-link tab-menu" #Depositor data-toggle="tab" href="#Depositor" (click)="onDepositorTabClick()">
            <span class="fa fa-address-card fa-lg"></span>
            ข้อมูลผู้ฝาก
          </a>
        </li>
        <li class="nav-item ml-3">
          <a class="nav-link tab-menu" #DATab data-toggle="tab" href="#DA" (click)="onDATabClick()">
            <span class="fa fa-home fa-lg"></span>
            ข้อมูล DA
          </a>
        </li>
        <li class="nav-item ml-3">
          <a class="nav-link tab-menu" #ReqDocTab data-toggle="tab" href="#ReqDoc" (click)="onreqdocTabClick()">
            <span class="fa fa-book fa-lg"></span>
            ขอเอกสาร
          </a>
        </li>
      </ul>
    </div>

    <div class="col-3 text-center my-auto">
      <button class="btn btn-primary hover-grey col-4 mr-2" *ngIf="role.dpa_button_sms" (click)="sms()">SMS</button>
      <button class="btn btn-primary hover-grey col-4 ml-2" *ngIf="role.dpa_button_email" (click)="email()">Email</button>
    </div>

  </div>
</nav>
<div class="tab-content" id="nav-tabContent">
  <div class="tab-pane fade show active" id="CustomerProfile" role="tabpanel" aria-labelledby="nav-home-tab">
    <app-customer-profile (GetDataSave)='GetSavedContact($event)'></app-customer-profile>
  </div>
  <div class="tab-pane fade" id="Details" role="tabpanel" aria-labelledby="nav-profile-tab">
    <app-customer-detail (GetDataSave)='GetSavedContact($event)'></app-customer-detail>
  </div>
  <div class="tab-pane fade" id="ContactReport" role="tabpanel" aria-labelledby="nav-contact-tab">
    <app-contact-history></app-contact-history>
  </div>
  <div class="tab-pane fade" id="Depositor" role="tabpanel" aria-labelledby="nav-contact-tab">
    <app-depositor-info></app-depositor-info>
  </div>
  <div class="tab-pane fade" id="DA" role="tabpanel" aria-labelledby="nav-contact-tab">
    <app-customer-da-data></app-customer-da-data>
  </div>
  <div class="tab-pane fade" id="ReqDoc" role="tabpanel" aria-labelledby="nav-contact-tab">
    <app-customer-req-doc></app-customer-req-doc>
  </div>
</div>


<!-- Modal SMS-->
<div class="modal fade" id="smsModal" tabindex="-1" role="dialog" aria-labelledby="smsModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="smsModalLabel">Select SMS template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label class="required">เลือก SMS Template</label>
          </div>
          <div class="col-7">
            <select class="form-control" (change)="smsChange()" [(ngModel)]="selectedSms">
              <option value="">เลือก</option>
              <option *ngFor="let s of smsTemplate" [value]="s.dpa_externalsmstemplateid">
                {{s.dpa_name}}
              </option>
            </select><span class="text-danger" *ngIf="submittedSms && (selectedSms == null || selectedSms == '')">
              กรุณาระบุ SMS Template
            </span>
          </div>

          <div class="col-12 mt-3 ">
            <div [innerHTML]="smsText" class="border border-secondary p-3 overflow-auto"></div>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmSMS()">OK</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('smsModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Email-->
<div class="modal fade" id="emailModal" tabindex="-1" role="dialog" aria-labelledby="emailModalLabel" aria-hidden="true"
  data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="emailModalLabel">Select Email template</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-3 text-right">
            <label class="required">เลือก Email Template</label>
          </div>
          <div class="col-9">
            <select class="form-control" (change)="emailChange()" [(ngModel)]="selectedEmail">
              <option value="">เลือก</option>
              <option *ngFor="let e of emailTemplate" [value]="e.templateid">
                {{e.title}}
              </option>
            </select>
            <span class="text-danger" *ngIf="submittedEmail && (selectedEmail == null || selectedEmail == '')">
              กรุณาระบุ Email Template
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="">ไฟล์แนบ</label>
          </div>
          <div class="col-9">
            <div [innerHTML]="attachments" class="border border-secondary p-3 overflow-auto"></div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <div class="border border-secondary p-3 overflow-auto">
              <div id="summernote"></div>
            </div>
          </div>

          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmEmail()">OK</button>
            <button type="button" class="btn btn-info ml-2" (click)="CloseModal('emailModal')">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customer/customer.component.html